export default __webpack_public_path__ + "static/media/products_total_orders.3005e618.svg";